import React from 'react'
import { createRoot } from "react-dom/client"
import App from "./components/app.js"
import _ from 'lodash-es'
import i18n from "./i18n/i18n.js"

globalThis._ = _
globalThis.t = i18n.t
const domNode = document.getElementById("root");
const root = createRoot(domNode);
root.render(<App />)
